import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notification__body" }
const _hoisted_2 = { class: "notification__icon-column" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "notification__close-column"
}
const _hoisted_5 = { class: "notification__icon-wrap" }
const _hoisted_6 = { class: "notification__footer" }

import { computed, ref, onMounted } from 'vue';

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';

import '@/components/ui/notifications/ThePush/style.scss';

// [START] Types and interfaces
type Type = 'success' | 'error' | 'warning' | 'info';

export interface IProps {
  id: string;
  type: Type;
  message: string;
  footer: string;
  showClose?: boolean;
  duration?: number;
}
// [END] Types and interfaces

// [START] Props

export default /*#__PURE__*/_defineComponent({
  __name: 'ThePush',
  props: {
    id: {},
    type: {},
    message: {},
    footer: {},
    showClose: { type: Boolean },
    duration: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }) {

const props = __props;


// [END] Props

// [START] Emits

// [END] Emits

// [START] Variables
const timer = ref<number | ReturnType<typeof setTimeout>>(-1);
const startedAt = ref(0);
// [END] Variables

// [START] Computed
const classList = computed(() => {
  const typeToClassMap = {
    success: ' notification--success',
    error: ' notification--error',
    warning: ' notification--warning',
    info: ' notification--info',
  };

  return typeToClassMap[props.type] || '';
});

const iconName = computed(() => {
  const typeToIconMap = {
    success: 'CheckCircle',
    error: 'AlertCircle',
    warning: 'AlertTriangle',
    info: 'AlertCircle',
  };

  return typeToIconMap[props.type] || 'AlertCircle';
});
// [END] Computed

// [START] Hooks
onMounted(() => {
  if (props.duration) {
    startedAt.value = Date.now();
    timer.value = setTimeout(handleClose, props.duration);
  }
});
// [END] Hooks

// [START] Methods
const handleClose = () => {
  emits('close');
};
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification", classList.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SmIcon, {
          name: iconName.value,
          class: "notification__icon"
        }, null, 8, ["name"])
      ]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("p", {
          class: "notification__message",
          innerHTML: props.message
        }, null, 8, _hoisted_3)
      ]),
      (props.showClose)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SmIcon, {
                name: "Cross",
                size: "12",
                class: "notification__close",
                onClick: handleClose
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "footer")
    ])
  ], 2))
}
}

})